import { TextField } from '@mui/material';
import { FC } from 'react';
import { BaseTextFieldProps } from '../types/global';

const BaseTextField: FC<BaseTextFieldProps> = ({
  value,
  name,
  feature = null,
  key = null,
  label,
  multipleLines = 1,
  readOnly = false,
}) => {
  return (
    <TextField
      label={label}
      multiline
      fullWidth
      name={name}
      value={value}
      InputProps={{ readOnly: readOnly }}
      variant='outlined'
      rows={multipleLines}
    />
  );
};

export default BaseTextField;
